<template>
  <div class="">
    <div v-if="loader" class="loader-wrapper"></div>
    <div v-if="loader" class="loader"></div>
    <!--
    <ul class="nav nav-tabs nav-justified">
      <li class="active"><a data-toggle="tab" id="tab1" href="#hk">Hauptartgrp.</a></li>
      <li><a data-toggle="tab" id="tab2" href="#br">Marken</a></li>
    </ul>

    <div class="tab-content" style="padding-bottom:100px;">
      <div id="hk" class="tab-pane fade in active">
        <div class="rowX">
          <stats-maincategory></stats-maincategory>
          <br><br><br>
        </div>
      </div>
      <div id="br" class="tab-pane fade">
        <div class="rowX">
          <stats-brand></stats-brand>
          <br><br><br>
        </div>
      </div>
    </div>
    -->

    <div class="container-fluid">
      <router-view></router-view>
    </div>

    <!--<div class="row">
      <div class="col-xs-12">        
        <div class="row">
          <stats-maincategory></stats-maincategory>
          <stats-brand></stats-brand>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import StatsMaincategory from '@/components/StatsMaincategory'
import StatsBrand from '@/components/StatsBrand'

export default {
  name: 'dashboard',
  components: { StatsMaincategory, StatsBrand },
  data () {
    return {
      years: 'test',
      names: {
        hatg: '',
        atg: '',
        brand: ''
      },
      loader: 0
    }
  },
  methods: {
    setName: function(type,value) {
      if(type=='hatg') {
        this.names.hatg = value
      }
      if(type=='atg') {
        this.names.atg = value
      }
      if(type=='brand') {
        this.names.brand = value
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- Here comes all CSS Styles which count for more elements -->
<style lang="scss">
body {
  color: #2c2c2c;
}
@import 'src/assets/style/spinthatshit/loaders.scss';

.loader-wrapper-sm,
.loader-wrapper-sb,
.loader-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0,0,0,.5);
  z-index: 3;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 3px;
}
.loader-sm,
.loader-sb,
.loader {
  width: 100px;
  height: 100px;
  background-color: transparent;
  color: white;
  position: absolute;
  display: inline-block;
  top: 130px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 4;
  border-radius: 10px;
  @include loader03;
  position: absolute;
}
.link:hover {
  cursor: pointer
}
.settings {
  width: 300px;
  min-height: 100px;
  background-color: white;
  box-shadow: 0px 3px 5px rgba(0,0,0,.5);
  color: #555555;
  position: absolute;
  display: inline-block;
  top: 0px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 3;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  text-align: center;
}
.settings .closeBtn {
  padding: 10px;
  margin:10px;
}
.settings .divider {
  padding: 10px;
  opacity: .5;
  border-top: 2px solid black;
}
.settings .link {
  padding: 10px;
  border: 2px solid transparent;
  margin: 10px;
  border-radius: 5px;
}
.settings .link:hover:not(.closeBtn) {
  border: 2px solid black;
}
.settings p.link {
  border-bottom: none;
}
.back {
  line-height: 30px;
  padding-right:30px;
  font-size:20px;
  text-align:left;
  float: left;
  width: 30px;
  margin-left: 15px;
  height: 30px;
  background: url(./../assets/images/zurueck.png) no-repeat 0 0 transparent;
  background-size: 100%;
}
.settingsOpener {
  line-height: 30px;
  padding-right:30px;
  font-size:20px;
  text-align:right;
  float: right;
  width: 30px;
  height: 30px;
  margin-right: 15ppx;
  background: url(./../assets/images/raedchen.png) no-repeat 0 0 transparent;
  background-size: 100%;
}
.settingsOpener:hover,
.back:hover {
  cursor: pointer;
}
.chartWrapper {
    position: relative;
    width: 100%;
}
.chartItem {
  padding: 0px;
  height: 200px;
}
tr:hover:not(:first-child),
tr:hover {
  background-color: #f8f8f8;
  cursor: pointer;
}
table.table.card-table > tbody > tr:hover:not(:first-child) > td,
table.table.card-table > tbody > tr:hover > td {
  color: inherit;
}
.names {
  position:absolute;
  top:15px;
  text-align:center;
  width:100%;
}
.title-one {
  font-size: 24px;
  font-weight: 500;
}
@media(max-width: 400px) {
  .title-one {
    font-size: 16px;
  }
}
.title-two {
  font-size: 16px;
  font-weight: 200;
}
.date {
  padding: 30px 0;
}
.date a {
  color: #ccc;
  padding: 0 7px;
  font-size: 16px;
  text-decoration: none;
}    
.date a.active,
.date a:hover {
  color: #3b547d;
  font-weight: bold;
}
.table.card-table td:first-child {
  text-align: right;
  width: 10px;
}
.table.card-table td {
  text-align: right;
  width: 50%;
}
.table.card-table td:first-child {
  text-align: left;
  word-wrap:break-word;
}
.table.card-table td span {
  color:#ccc;
  font-size:12px;
}
@media(max-width: 400px) {
  .table>tbody>tr>td, 
  .table>tbody>tr>th, 
  .table>tfoot>tr>td, 
  .table>tfoot>tr>th, 
  .table>thead>tr>td, 
  .table>thead>tr>th {
    //padding: 8px 0;
  }
  table.table.card-table > tbody > tr:hover:not(:first-child) > td,
  table.table.card-table > tbody > tr:hover > td {
    //padding: 8px;
  }
  tr {
    font-size: 11px;
  }
}

.next {
  line-height: 20px;
  padding-right:0px;
  font-size:20px;
  text-align:left;
  float: left;
  width: 20px;
  height: 20px;
  background: url(./../assets/images/pfeil_runter.png) no-repeat 0 0 transparent;
  background-size: 100%;
  //transform: rotate(-90deg);
}

.colorPill {
  /*width: 10px;
  height: 10px;
  background-color: #006633;
  overflow: hidden;
  display: inline-block;
  border-radius: 10px;
  margin-right: 15px;
  border: 1px solid white;*/
}

tr:nth-child(1) td.colorPill:first-child {
  border-left: 10px solid #003366;
}
tr:nth-child(2) td.colorPill:first-child {
  border-left: 10px solid #1d71b8;
}
tr:nth-child(3) td.colorPill:first-child {
  border-left: 10px solid #00a19a;
}
tr:nth-child(4) td.colorPill:first-child {
  border-left: 10px solid #66aa66;
}
tr:nth-child(5) td.colorPill:first-child {
  border-left: 10px solid #006633;
}

.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {
    border: 1px solid #ddd;
    border-right: 0;
    border-top: 0;
    border-left: 0;
}
.nav-tabs.nav-justified>li>a {
    border-radius: 0;
     border-bottom-color: #f8f8f8;
  }
  .nav-tabs.nav-justified>.active>a, 
  .nav-tabs.nav-justified>.active>a:focus, 
  .nav-tabs.nav-justified>.active>a:hover {
      border-bottom-color: blue;
  }

  .label {
    padding: .1em;
  }
@media (max-width: 768px) {
  
  .label {
    display: block;
    text-align: left;
  }
}

.chart {
    position: relative;
    display: block;
    width: 100%;
    direction: ltr;
}

.downward,
.upward,
.stagnation {
  width: 200px;
  height: 39px;
  float: left;
  padding-left: 52px;
  line-height: 40px;
  text-align: left;
}

@media (max-width: 602px) {
  
  .downward,
  .upward,
  .stagnation {
    width: 150px;
    height: 39px;
    float: left;
    padding-left: 52px;
    line-height: 40px;
    text-align: left;
  }

}

.downward {
  background: url(./../assets/images/negative2.png) no-repeat 0 -5px transparent;
  color: red!important;
  background-size: auto;
}
.upward {
  background: url(./../assets/images/positive2.png) no-repeat 0 -5px transparent;
  color: green!important;
  background-size: auto;
}
.stagnation {
  background: url(./../assets/images/stagnation.png) no-repeat 0 -5px transparent;
  color: grey!important;
  background-size: auto;
}

@media (max-width: 602px) {
  
  .downward,
  .upward,
  .stagnation {
    width: 70px;
    height: 39px;
    float: left;
    padding-left: 0;
    line-height: 50px;
    text-align: left;
    background-size: 33%;
    font-size: 12px;
  }

}

.nav-tabs.nav-justified>li {
    display: table-cell;
    width: 1%;
    float: none;
}

/*

path.highcharts-data-label-connector {
  display: none;
}
g.highcharts-label.highcharts-data-label {
  display: none;
}
#users-chart-1 {  
  float: right;
}
#users-chart-1 .highcharts-container {
  position: absolute !important;
  bottom: -87px;
  z-index: 1 !important;
  right: -25px;
  fill-opacity: .5;
}

#users-chart {  
  float: left;
  height: 235px!important;
}
#users-chart .highcharts-container {
  position: absolute !important;
  top: 50px;
  left: -110px;
  z-index: 0 !important;
}
.highcharts-background {
  background-color: transparent;
}
rect {
    fill: transparent;
}

*/


.c3 svg{font-size:12px}.c3 line,.c3 path{fill:none;stroke:#999}.c3 path.domain{shape-rendering:crispEdges}.c3 text{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.c3-bars path,.c3-event-rect,.c3-legend-item-tile,.c3-xgrid-focus,.c3-ygrid{shape-rendering:crispEdges}.c3-chart-arc path{stroke:#fff}.c3-chart-arc text{fill:#fff;font-size:13px}.c3-grid line{stroke:#aaa}.c3-grid text{fill:#aaa}.c3-xgrid,.c3-ygrid{stroke-dasharray:3 3}.c3-text{font-weight:500}.c3-text.c3-empty{fill:grey;font-size:2em}.c3-line{stroke-width:2px}.c3-area{stroke-width:0;opacity:.4}.c3-circle._expanded_{stroke-width:1.5px;stroke:#fff}.c3-selected-circle{fill:#fff;stroke-width:2px}.c3-bar{stroke-width:0}.c3-bar._expanded_{fill-opacity:.75}.c3-chart-arcs-title{font-size:1.3em}.c3-chart-arcs .c3-chart-arcs-background{fill:#e0e0e0;stroke:none}.c3-chart-arcs .c3-chart-arcs-gauge-unit{fill:#333;font-size:15px}.c3-chart-arcs .c3-chart-arcs-gauge-max,.c3-chart-arcs .c3-chart-arcs-gauge-min{fill:#999}.c3-chart-arc .c3-gauge-value{fill:#333;font-size:28px}.c3-target.c3-focused{opacity:1}.c3-target.c3-focused path.c3-line,.c3-target.c3-focused path.c3-step{stroke-width:2px}.c3-target.c3-defocused{opacity:.3!important}.c3-region{fill:#546e7a;fill-opacity:.1}.c3-brush .extent{fill-opacity:.1}.c3-legend-item{font-size:12px}.c3-legend-background{fill:#fff;stroke:#d3d3d3;stroke-width:1;opacity:.75}.c3-tooltip{border-collapse:collapse;border-spacing:0;background-color:#fff;empty-cells:show;opacity:.95}.c3-tooltip th{background-color:#333;padding:4px 10px;text-align:center;color:#fff;border:1px solid #333;font-weight:500}.c3-tooltip td{font-size:12px;padding:6px 10px;background-color:#fff;border:1px solid #ddd}.c3-tooltip td>span{display:inline-block;width:10px;height:10px;margin-right:6px}.c3-tooltip td.value{text-align:right}

.chart-container{position:relative;width:100%}.chart-container.has-scroll{overflow-x:scroll;overflow-y:visible;max-width:100%}@media (max-width:768px){.chart-container{overflow-x:scroll;overflow-y:visible;max-width:100%}}.chart{position:relative;display:block;width:100%;direction:ltr}.chart.has-minimum-width{min-width:600px}.has-fixed-height{height:400px}.chart-pie{width:100%;height:400px;min-width:500px}.c3 svg{font-size:12px}.c3 line,.c3 path{fill:none;stroke:#999}.c3 path.domain{shape-rendering:crispEdges}.c3 text{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.c3-bars path,.c3-event-rect,.c3-legend-item-tile,.c3-xgrid-focus,.c3-ygrid{shape-rendering:crispEdges}.c3-chart-arc path{stroke:#fff}.c3-chart-arc text{fill:#fff;font-size:13px}.c3-grid line{stroke:#aaa}.c3-grid text{fill:#aaa}.c3-xgrid,.c3-ygrid{stroke-dasharray:3 3}.c3-text{font-weight:500}.c3-text.c3-empty{fill:grey;font-size:2em}.c3-line{stroke-width:2px}.c3-area{stroke-width:0;opacity:.4}.c3-circle._expanded_{stroke-width:1.5px;stroke:#fff}.c3-selected-circle{fill:#fff;stroke-width:2px}.c3-bar{stroke-width:0}.c3-bar._expanded_{fill-opacity:.75}.c3-chart-arcs-title{font-size:1.3em}.c3-chart-arcs .c3-chart-arcs-background{fill:#e0e0e0;stroke:none}.c3-chart-arcs .c3-chart-arcs-gauge-unit{fill:#333;font-size:15px}.c3-chart-arcs .c3-chart-arcs-gauge-max,.c3-chart-arcs .c3-chart-arcs-gauge-min{fill:#999}.c3-chart-arc .c3-gauge-value{fill:#333;font-size:28px}.c3-target.c3-focused{opacity:1}.c3-target.c3-focused path.c3-line,.c3-target.c3-focused path.c3-step{stroke-width:2px}.c3-target.c3-defocused{opacity:.3!important}.c3-region{fill:#546e7a;fill-opacity:.1}.c3-brush .extent{fill-opacity:.1}.c3-legend-item{font-size:12px}.c3-legend-background{fill:#fff;stroke:#d3d3d3;stroke-width:1;opacity:.75}.c3-tooltip{border-collapse:collapse;border-spacing:0;background-color:#fff;empty-cells:show;opacity:.95}.c3-tooltip th{background-color:#333;padding:4px 10px;text-align:center;color:#fff;border:1px solid #333;font-weight:500}.c3-tooltip td{font-size:12px;padding:6px 10px;background-color:#fff;border:1px solid #ddd}.c3-tooltip td>span{display:inline-block;width:10px;height:10px;margin-right:6px}.c3-tooltip td.value{text-align:right}

.svg {
  width: 80%;
}

.tab-content {
  padding-top: 10px;
}
.names {
  width: 80%;
  margin: 0 auto;
  top: 0;
}

input {
  font-size: 16px!important;
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?4b199431